import { FC } from 'react';
import { IICartGroupBar } from 'mod/cart/interface';
import { Checkbox } from 'antd';
import type { CheckboxChangeEvent } from 'antd/lib/checkbox';
import OrderProductTag from '@base/snippets/OrderProductTag';
import styles from './cartMenu.module.less';
import { CartGroupHeaderTip } from 'mod/cart/CartGroupHeaderTip';
import { CartType } from '@base/cart/useCart';

type IGroupHeaderProps = {
    data: IICartGroupBar;
    isBatchList: boolean;
    groupCheckAll: boolean;
    onGroupCheckAll: (e: CheckboxChangeEvent) => void;
    loadCart: CartType['loadCart'];
    editable: boolean;
};

export const GroupHeader: FC<IGroupHeaderProps> = props => {
    const { data, isBatchList, groupCheckAll, onGroupCheckAll, loadCart, editable } = props;
    const { tag, tips } = data;

    return !tag && !tips ? null : (
        <div className={styles['group-header']}>
            <div className={styles['col-checkbox']}>
                {(!isBatchList || editable) && (
                    <Checkbox
                        // value={`group-${gr}`}
                        checked={groupCheckAll}
                        onChange={onGroupCheckAll}
                        className={isBatchList ? styles['checkbox-batch'] : styles['checkbox-common']}
                        // disabled={!batchActive && (isChangingQty || stockNum === 0)}
                    />
                )}
            </div>

            {!!tag && (
                <OrderProductTag tag={tag} absolute={false}/>
            )}

            <CartGroupHeaderTip className={styles.tips} data={data} loadCart={loadCart}/>
        </div>
    )
};
